import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import PackageConfirmationComponent from '../containers/PackageConfirmationComponent';
import HomePageComponent from '../components/HomePageComponent';
import TermsConditionsComponent from '../components/TermsConditionsComponent';
import PolicyDocumentComponent from '../components/PolicyDocument';
import Apis from '../helpers/gaEvent';
import useDataStore from '../store/dataStore';
import ABHFLCustomComponent from '../components/ABHFL/ABHFLCustomComponent'
import SelfFundComponent from '../components/SelfFundComponent';
import SMFGStatusComponent from '../components/SMFGStatusComponent';
import PFCLandingComponent from '../components/PFC/PFCLandingComponent';
import PFCPreviewPageComponent from '../components/PFC/PFCPreviewPageComponent';
import { useHistory } from 'react-router-dom';
import { trackBackendEvent } from '../helpers/events';
import {hotjar} from 'react-hotjar';

const normalizeSource = source => typeof source === 'string' ? source.trim().toLowerCase() : '';
const isPoonawallaSource = source => (normalizeSource(source) === 'poonawalla') ||  (normalizeSource(source) === 'test poonawala');

const Main = () => {
  //contextProvider
  hotjar.initialize("3617408", "6");
  hotjar.identify('3617408', { userProperty: 'user entered' });
  const getBaseUrl = () => {
    if (window.location.hostname === 'localhost') {
      return 'https://affinity.medibuddy.in';
    } else {
      return window.location.origin;
    }
  };

  const history = useHistory();
  hotjar.event('Affinity-Landing-Page');
  useEffect(() => {
    const fetchData = async () => {
      try{
      // Skip old logic for /self-fund route - handled by SelfFundComponent
      if (window.location.pathname === '/self-fund') {
        return;
      }
      const parsed = queryString.parse(window.location.search);
      let source = parsed.utm_source;
      let customerdetails = parsed.customerdetails;
      let token = parsed.token;
      let packageName = parsed.PackageName || parsed.packageName;
      if (packageName) {
        packageName = decodeURIComponent(packageName).replace(/^["']|["']$/g, '');
      }
      const sourceAllowedForDetailParam = ["capriglobal", "testingdemoall", "capriglobalcapitalltd", "policyguru", "smfg"]
      console.log("utm", source);
      if (source) {
        localStorage.setItem('source', source); 
      } else {
        source = localStorage.getItem('source') || 'default'; 
      }

        const resConfig = await fetch(`${getBaseUrl()}/patientswebapp/affinity/vendorConfigrations?source=${source}`).then((t) =>
        t.json()
      );
      // Hardcoded fallback for SMFG when backend has no config
      if (source && source.toLowerCase() === 'smfg') {
        if (!resConfig.data) {
          resConfig.data = {};
        }
        if (!resConfig.data.packages) {
          resConfig.data.packages = [];
        }
      }
      useDataStore.setState(resConfig)
      // sessionStorage.setItem('vendorConfig', JSON.stringify(resConfig));

      // Redirect to Checkout if packageName query param matches a package
      if (packageName && resConfig.data?.packages) {
        const packageNameLower = packageName.toLowerCase();
        const matchedPackage = resConfig.data.packages.find(pkg => {
          if (pkg.title && pkg.title.toLowerCase() === packageNameLower) return true;
          if (pkg.id && pkg.id.toString().toLowerCase() === packageNameLower) return true;
          if (pkg.urlSlug && pkg.urlSlug.toLowerCase() === packageNameLower) return true;
          return false;
        });
        if (matchedPackage) {
          history.replace({
            pathname: '/Checkout',
            state: { params: { packageDetails: matchedPackage, isAuthentic: true } }
          });
          return;
        }
      }

      // Handle customerdetails param
      if (sourceAllowedForDetailParam.includes(source.toLowerCase()) && token) {
        const userDataResponse = await fetch(`${getBaseUrl()}/patientswebapp/affinity/fetchCustomerDetailsLandingPage`, {
          method: 'POST',
          headers: {
                        'Content-Type': 'application/json'
                    },
          body: JSON.stringify({
            token: token
          })
        }).then((t) =>
          t.json()
        );
        if (!(userDataResponse.success===1)) {
          console.error('Failed to get details of user');
        } else {
          // Fetch the package list (from store, API, or config)
          const allPackages = useDataStore.getState().data.packages;
          let userData = userDataResponse.data;

          await trackBackendEvent({
            eventName: 'AFFINITY_LANDING_PAGE_EVENT',
            eventVersion: '1-0-0',
            eventData: {
              name: userDataResponse.name || '',
              email: userDataResponse.email || '',
              phoneNumber: userDataResponse.mobile || '',
              referral: userDataResponse.referralCode || '',
              vendorId: allPackages[0].pmEntityId
            }
          });

          let packageDetails = null;
          if (userData.packageId && allPackages) {
            packageDetails = allPackages.find(pkg => pkg.id === userData.packageId.toString());
            console.log("packageDetails",packageDetails)
          }
          if (userData.packageId && packageDetails) {
            console.log("Navigating with state:", { 
              params: { 
                packageDetails: packageDetails, 
                prefillData: userData 
              } 
            });

            if (userData.nomineeDetails) {
              userData = {
                ...userData,
                nomineeName: userData.nomineeDetails.name,
                nomineeRelation: userData.nomineeDetails.relation,
                nomineeDob: userData.nomineeDetails.dob
              }
            }
            // Pass details via state to Checkout
            history.replace({
              pathname: '/Checkout',
              state: { params: { packageDetails: packageDetails, prefillData: userData } }
            });
            console.log("Checkout")
            return; // Stop further execution
          }
        } 
      }

      if (sourceAllowedForDetailParam.includes(source.toLowerCase()) && customerdetails) {
        try {
          let decoded = JSON.parse(atob(customerdetails));
          let packageDetails = null;

          // Fetch the package list (from store, API, or config)
          const allPackages = useDataStore.getState().data?.packages || [];

          if (allPackages.length > 0) {
            await trackBackendEvent({
              eventName: 'AFFINITY_LANDING_PAGE_EVENT',
              eventVersion: '1-0-0',
              eventData: {
                name: decoded.name || '',
                email: decoded.email || '',
                phoneNumber: decoded.mobile || '',
                referral: decoded.referralCode || '',
                vendorId: allPackages[0].pmEntityId
              }
            });
          }

          if (decoded.packageId && allPackages) {
            packageDetails = allPackages.find(pkg => pkg.id === decoded.packageId);
            console.log("packageDetails",packageDetails)
          }

            // Flatten the address object if it exists
            if (decoded.address) {
              decoded = {
                  ...decoded,              // Spread all existing properties
                  city: decoded.address.city,
                  state: decoded.address.state,
                  Address: `${decoded.address.fullAddress}`  // Rename fullAddress to address
              };
              delete decoded.address;      // Remove the original nested address object
            }

          if (decoded.nominee) {
            decoded = {
              ...decoded,
              nomineeName: decoded.nominee.name,
              nomineeRelation: decoded.nominee.relation,
              nomineeAge: decoded.nominee.age,
              nomineeDob: decoded.nominee.dob
            }
          }

          // Route to self-fund for SMFG source (requires customerdetails with audId)
          if (source && source.toLowerCase() === 'smfg') {
            return;
          }

          // Other sources require valid packageDetails for Checkout
          if (decoded.packageId && packageDetails) {
            console.log("Navigating with state:", { 
              params: { 
                packageDetails: packageDetails, 
                prefillData: decoded 
              } 
            });

            // Force submit-only label for policyguru customerdetails flow
            if (source && source.toLowerCase() === 'policyguru') {
              localStorage.setItem('showSubmitOnly', 'true');
            }
            
            // Pass details via state to Checkout
            history.replace({
              pathname: '/Checkout',
              state: { params: { packageDetails: packageDetails, prefillData: decoded } }
            });
            console.log("Checkout")
            return;
          }
        } catch (e) {
          console.error('Invalid details param', e);
        }
      }


      document.title = 'Medibuddy Affinity';
      Apis.pageView();
    }catch(error){
      console.error("Error fetching vendor configurations:", error);
    }
    };
    fetchData();
  }, [history]);
  hotjar.stateChange(`/home?utm_source=${source}`);
  const data = useDataStore((state) => state.data);
  // console.log("data",data)
  if (hotjar.initialized()) {
    hotjar.identify('3617408', { userProperty: 'hotjar triggered' });
  }

  return (
    <div className="Main">
        <Switch>
          {/* <Route path="/self-fund" exact component={SelfFundComponent} /> */}
          <Route path="/consent" exact component={PFCPreviewPageComponent} />
          {/* <Route path="/smfg-status" exact component={SMFGStatusComponent} /> */}
          <Route path="/home" exact render={(props) => {
            const source = new URLSearchParams(props.location.search).get('utm_source');
            if (isPoonawallaSource(source)) {
              return <PFCLandingComponent />;
            }
            if (!data) return null;
            return <HomePageComponent />;
          }} />
          <Route exact path="/" render={(props) => (
            <Redirect to={`/home${props.location.search}`} />
          )} />
          
          {data && (
            <>
              <Route path="/Checkout" exact component={PackageConfirmationComponent} />
              <Route path="/terms-and-conditions" exact component={TermsConditionsComponent} />
              <Route path="/policyDoc" exact component={PolicyDocumentComponent} />
              <Route path="/abhfl_home" exact component={ABHFLCustomComponent} />
            </>
          )}
        </Switch>
    </div>
  );
};
export default Main;